// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"586":"8e22c0f5","741":"6df0ab15"}[chunkId] + ".chunk.js";
};